import { useEffect, useMemo } from 'react';
import * as React from 'react';
import ReactDOM from 'react-dom';
import { Transition, TransitionStatus } from 'react-transition-group';

import {
  CloseButton,
  Container,
  ContainerStyleProps,
  Overlay,
  transitionDuration,
} from './style';

export interface ModalBasicProps {
  isOpen: boolean;
  handleClose: () => void;
  hideCloseButton?: boolean;
}

export interface ModalBaseProps extends ModalBasicProps, ContainerStyleProps {}

// モーダルの多重表示のため、z-indexをグローバル変数で管理
let globalZIndex = 2000;

const ModalBaseContent: React.FC<
  ModalBaseProps & {
    transitionStatus: TransitionStatus;
  }
> = ({
  transitionStatus,
  isOpen,
  desktopWidth,
  mobileWidth,
  desktopHeight,
  mobileHeight,
  backgroundColor,
  paddingSize,
  radiusSize,
  handleClose,
  hideCloseButton,
  children,
}) => {
  // モーダル多重表示のため z-indexを加算・減算
  const baseZIndex = useMemo(() => {
    return globalZIndex;
  }, []);
  useEffect(() => {
    globalZIndex += isOpen ? 3 : -3;
  }, [isOpen]);

  return (
    <Overlay
      transitionStatus={transitionStatus}
      baseZIndex={baseZIndex}
      onClick={handleClose}
    >
      <Container
        transitionStatus={transitionStatus}
        baseZIndex={baseZIndex}
        desktopWidth={desktopWidth}
        mobileWidth={mobileWidth}
        desktopHeight={desktopHeight}
        mobileHeight={mobileHeight}
        backgroundColor={backgroundColor}
        paddingSize={paddingSize}
        radiusSize={radiusSize}
        onClick={e => e.stopPropagation()}
      >
        {hideCloseButton ? (
          <></>
        ) : (
          <CloseButton baseZIndex={baseZIndex} onClick={handleClose} />
        )}
        {children}
      </Container>
    </Overlay>
  );
};

// モーダルはz-indexのスタッキングコンテキスト問題を回避するため
// Portalを使って別ルートでレンダリングする
// 参考: https://ics.media/entry/200609/
const modalRoot = document.getElementById('modal-root')!;

const ModalBase: React.FC<ModalBaseProps> = props => {
  const { isOpen } = props;

  return ReactDOM.createPortal(
    <Transition
      in={isOpen}
      timeout={transitionDuration}
      mountOnEnter
      unmountOnExit
    >
      {status => <ModalBaseContent transitionStatus={status} {...props} />}
    </Transition>,
    modalRoot,
  );
};

export default ModalBase;
